import { NextSeo } from "next-seo";
import { LoginPage } from "~/modules/auth/pages/login";
import { Navbar } from "~/components/Navbar/component";
import { PageTrack } from "~/modules/analytics/components/PageTrack";
import { Routes } from "~/routes";

// // // //

export default function Login() {
    return (
        <PageTrack route={Routes.login}>
            <NextSeo title="Login" />
            <Navbar route={Routes.login} user={undefined} />
            <LoginPage />
        </PageTrack>
    );
}
